export default "__VITE_ASSET__BNrihGZ6__"